import { useQuery } from '@tanstack/react-query';
import { caseApplicationsService, GET_CASES_CLIENTS } from '@/api';

// Shares the queryKey with DashboardCasesScreen (components/screens/dashboard/cases/Cases.tsx)
// so both hit the same TanStack Query cache entry instead of duplicating the request.
export const useFirstClientCaseId = () => {
	const { data, isLoading } = useQuery({
		queryKey: [GET_CASES_CLIENTS],
		queryFn: () => caseApplicationsService.getAll({ page: 1, limit: 1 }),
	});

	const firstCase = data?.data.items[0];

	return {
		caseId: firstCase?.id,
		numericalOrder: firstCase?.numerical_order,
		totalCases: data?.data.totalItems,
		isLoading,
	};
};
